import { render, staticRenderFns } from "./OperaProjectSoWindow.vue?vue&type=template&id=4671bcaa&"
import script from "./OperaProjectSoWindow.vue?vue&type=script&lang=js&"
export * from "./OperaProjectSoWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports